import { Component, Input } from "@angular/core";
import { EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LoggedInUserInformationService, LOGIN_INFO_REDUCER_NAME, UserInfo, UserInfoStateStructure } from "@ptl/account-management";
import { RedirectService } from "src/app/angular-elements/shared/services/redirect.service";
import { ReducerUtilityService } from "src/app/shared/utility-services/reducer-utility.service";
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { FieldAgentConfirmModalComponent } from "./field-agent-confirm-modal/field-agent-confirm-modal.component";
import { ConnectureEnrollPermissionsService } from "./connecture-enroll-sso-permissions.service";

@Component({
    selector: 'app-connecture-enroll-sso',
    templateUrl: './connecture-enroll-sso.component.html',
    styleUrls: ['./connecture-enroll-sso.component.scss'],
    standalone: false
})
export class ConnectureEnrollSsoComponent {
   
  @Input() label;
  @Input() lob: LINE_OF_BUSINESS_ENUM;
  @Input() isPlanChange: boolean = false;
    
  userId = '';
  userInfo: UserInfo;

  isTelesalesUser = false;
  isFieldAgent = false;
  isLoading = false;

  constructor(
    private loggedInUserService: LoggedInUserInformationService,
    private reducerUtilityService: ReducerUtilityService,
    private entitlementHelper: EntitlementsHelperService,
    private redirectService: RedirectService,
    private connecturePermissionService: ConnectureEnrollPermissionsService,
    private matDialog: MatDialog
  ) { }

  async ngOnInit() {
    if (!this.lob) {
      this.lob = await this.entitlementHelper.getCurrentLobPromise();
    }

    // A fieldAgent is a telesales user, but not all telesales users are field agents
    this.isTelesalesUser = this.loggedInUserService.isAgentCubeForLOB(this.lob);
    this.isFieldAgent = this.loggedInUserService.isFieldAgentForLOB(this.lob);

    const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
    this.userId = loginInfo.userId;
    this.userInfo = loginInfo.userInfo;
  }
  
  async submitForm() {
    let destinationURL = await this.getDestinationUrl();
    if (!destinationURL) {
      return;
    }

    this.isLoading = true;
    
    const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
    if (await this.connecturePermissionService.setupConnecturePermissionsForSSO(loginInfo, this.lob, this.isPlanChange)) {
      let target = 'https://' + environment.external.vendors.agentCubeUrl;
      let postParams = { userName: this.userId, destinationURL: destinationURL, target }
      this.redirectService.post(postParams);
    }
    else {
      this.connecturePermissionService.showSSOError();
    }

    this.isLoading = false;
  }

  async getDestinationUrl(): Promise<string> {
    let destinationURL = 'CONNECTUREBROKERSSO';
    
    if (this.isTelesalesUser) {
      // Telesales users will get the telesales flow UNLESS they are field agent, then they have to answer a modal confirmation
      // That determines if they are on call with a client. Similar to the producer-change-agency checkbox at the bottom of the page
      let isTelesalesFlow = true;

      if (this.isFieldAgent) {
        // Modal will return true if the agent selects 'Yes, I am on a call with the client'
        let dialogRef = this.matDialog.open(FieldAgentConfirmModalComponent, {width: '350px', disableClose: true});
        let result = await dialogRef.afterClosed().toPromise();

        // Modal can be canceled entirely, so if the result is undefined we return
        if (result !== true && result !== false) {
          return null;
        }

        // Otherwise result should be a boolean we can assign directly
        isTelesalesFlow = result;
      }

      // If we are pure telesales or on a call with a client, we go to the telesales flow
      if (isTelesalesFlow) {
        destinationURL = 'CONNECTURETELESALESSSO'
      }
    }

    //plan change full broker key: CONNECTUREBROKERSSOMEMBER
    //plan change full telesales key: CONNECTURETELESALESSSOMEMBER
    if (this.isPlanChange) {
      destinationURL += 'MEMBER';
    }

    return destinationURL;
  }
}
